import React, { useState, Fragment, useEffect } from "react";
import PropTypes from "prop-types";

import { getFormattedMonthDateV3 } from "../../utils/dateTimeHelper";

import CustomModal from "../../components/modal";
import CommentForm from "../../containers/Forum/commentForm";
import EntriesPagination from "../../components/datatable/entriesPagination";

const CommentsList = props => {
  const [comments, setComments] = useState([]);
  const [currSelComment, setCurrSelComment] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [isCommentEditMode, setIsCommentEditMode] = useState(false);
  const [isReplyMode, setIsReplyMode] = useState(false);

  const [currSelReply, setCurrSelReply] = useState(null);
  const [showReplyDeleteModal, setShowReplyDeleteModal] = useState(false);
  const [isReplyEditMode, setIsReplyEditMode] = useState(false);

  useEffect(() => {
    setComments(props.comments);
  }, [props.comments]);

  // For comments
  const showDelModal = comment => {
    setCurrSelComment(comment);
    setShowDeleteModal(true);
  };

  const deleteComment = () => {
    setShowDeleteModal(false);
    props.deleteComment(currSelComment._id);
    setCurrSelComment(null);
  };

  const setCommentEditMode = comment => {
    setCurrSelComment(comment);
    setIsReplyEditMode(false);
    setIsReplyMode(false);
    setIsCommentEditMode(true);
  };

  const cancelUpdateComment = () => {
    setCurrSelComment(null);
    setIsCommentEditMode(false);
  };

  const updateComment = message => {
    props.updateComment({
      message: message,
      id: currSelComment._id
    });
    setCurrSelComment(null);
    setIsCommentEditMode(false);
  };

  // For replys
  const openReplyForm = comment => {
    setCurrSelComment(comment);
    setIsCommentEditMode(false);
    setIsReplyEditMode(false);
    setIsReplyMode(true);
  };

  const cancelReplyForm = () => {
    setCurrSelComment(null);
    setIsReplyMode(false);
  };

  const addReply = message => {
    props.addCommentReply({
      message: message,
      forumCommentId: currSelComment._id
    });
    setCurrSelComment(null);
    setIsReplyMode(false);
  };

  const setReplyEditMode = comment => {
    setCurrSelReply(comment);
    setIsReplyMode(false);
    setIsCommentEditMode(false);
    setIsReplyEditMode(true);
  };

  const cancelReplyUpdate = () => {
    setCurrSelReply(null);
    setIsReplyEditMode(false);
  };

  const updateReply = message => {
    props.updateCommentReply({
      message: message,
      id: currSelReply._id
    });
    setCurrSelReply(null);
    setIsReplyEditMode(false);
  };

  const showReplyDelModal = comment => {
    setCurrSelReply(comment);
    setShowReplyDeleteModal(true);
  };

  const deleteReply = () => {
    setShowReplyDeleteModal(false);
    props.deleteCommentReply(currSelReply._id);
    setCurrSelReply(null);
  };

  const showThisCommentReplys = commentIndex => {
    let newComments = [...comments];
    newComments[commentIndex].showReplys = true;
    setComments(newComments);
  };

  return (
    <div className="comments-list-container">
      <CustomModal
        title="Instant Consult"
        okayText="Yes"
        cancelText="No"
        openModal={showDeleteModal}
        cancelEvent={() => {
          setShowDeleteModal(false);
          setCurrSelComment(null);
        }}
        okayEvent={deleteComment}
        modalBodyContent={
          <p className="text-center mb-0">
            Are you sure you want to delete this comment?
          </p>
        }
      />

      <CustomModal
        title="Instant Consult"
        okayText="Yes"
        cancelText="No"
        openModal={showReplyDeleteModal}
        cancelEvent={() => {
          setShowReplyDeleteModal(false);
          setCurrSelReply(null);
        }}
        okayEvent={deleteReply}
        modalBodyContent={
          <p className="text-center mb-0">
            Are you sure you want to delete this reply?
          </p>
        }
      />
      {comments.length > 0 &&
        comments.map((comment, index) => {
          let fullName = "";

          if (comment.adminId) {
            fullName =
              comment.adminId.firstName + " " + comment.adminId.lastName;
          } else if (comment.doctorId) {
            fullName = "Dr " + comment.doctorId.firstName;

            if (comment.doctorId.lastName.trim() !== "") {
              fullName = fullName + " " + comment.doctorId.lastName.trim();
            }
          }

          return (
            <div key={index} className="comment-container mb-3">
              {isCommentEditMode === true &&
                currSelComment !== null &&
                currSelComment._id === comment._id && (
                  <CommentForm
                    message={
                      currSelComment !== null ? currSelComment.message : ""
                    }
                    buttonText="Update"
                    onFormSubmit={updateComment}
                    cancelForm={cancelUpdateComment}
                    showCancelButton={true}
                  />
                )}
              {(isCommentEditMode === false ||
                (isCommentEditMode === true &&
                  currSelComment !== null &&
                  currSelComment._id !== comment._id)) && (
                <Fragment>
                  <p
                    className="mb-1 w-100 overflow-wrap-word"
                    dangerouslySetInnerHTML={{
                      __html: comment.message.replace(
                        /(?:\r\n|\r|\n)/g,
                        "<br />"
                      )
                    }}
                  ></p>
                  <p className="font-demi-bold" style={{ fontSize: "12px" }}>
                    {fullName}&nbsp;|&nbsp;
                    {getFormattedMonthDateV3(comment.createdAt)}
                    {(isReplyMode === false ||
                      (isReplyMode === true &&
                        currSelComment !== null &&
                        currSelComment._id !== comment._id)) && (
                      <Fragment>
                        &nbsp;&nbsp;&nbsp;
                        <i
                          className="fas fa-reply font-col-primary pointer-cursor"
                          onClick={e => {
                            openReplyForm(comment);
                          }}
                        ></i>
                      </Fragment>
                    )}
                    {props.user !== null &&
                    comment.adminId &&
                    props.user._id === comment.adminId._id ? (
                      <Fragment>
                        &nbsp;&nbsp;&nbsp;
                        <i
                          className="fas fa-edit color-light-grey pointer-cursor"
                          onClick={e => {
                            setCommentEditMode(comment);
                          }}
                        ></i>
                      </Fragment>
                    ) : (
                      ""
                    )}
                    &nbsp;&nbsp;&nbsp;
                    {props.user !== null &&
                    (props.user.userType === "SUPER_ADMIN" ||
                      (comment.adminId &&
                        props.user._id === comment.adminId._id)) ? (
                      <i
                        className="fas fa-trash-alt color-red pointer-cursor"
                        onClick={e => {
                          showDelModal(comment);
                        }}
                      ></i>
                    ) : (
                      ""
                    )}
                  </p>
                </Fragment>
              )}
              <div style={{ marginLeft: "7%" }}>
                {isReplyMode === true &&
                  currSelComment !== null &&
                  currSelComment._id === comment._id && (
                    <CommentForm
                      buttonText="Publish Reply"
                      onFormSubmit={addReply}
                      cancelForm={cancelReplyForm}
                      showCancelButton={true}
                    />
                  )}
                {comment.replys.length > 0 &&
                  comment.replys.length > 1 &&
                  (comment.showReplys === undefined ||
                    comment.showReplys === false) && (
                    <p
                      className="reply-show-text"
                      onClick={e => {
                        showThisCommentReplys(index);
                      }}
                    >
                      Show {comment.replys.length} Replies...
                    </p>
                  )}

                {comment.replys.length > 0 &&
                  (comment.replys.length === 1 ||
                    (comment.showReplys !== undefined &&
                      comment.showReplys === true)) &&
                  comment.replys.map((reply, index) => {
                    let fullName = "";

                    if (reply.adminId) {
                      fullName =
                        reply.adminId.firstName + " " + reply.adminId.lastName;
                    } else if (reply.doctorId) {
                      fullName = "Dr " + reply.doctorId.firstName;

                      if (reply.doctorId.lastName.trim() !== "") {
                        fullName =
                          fullName + " " + reply.doctorId.lastName.trim();
                      }
                    }

                    return (
                      <div key={index} className="comment-container mb-3">
                        {isReplyEditMode === true &&
                          currSelReply !== null &&
                          currSelReply._id === reply._id && (
                            <CommentForm
                              message={
                                currSelReply !== null
                                  ? currSelReply.message
                                  : ""
                              }
                              buttonText="Update"
                              onFormSubmit={updateReply}
                              cancelForm={cancelReplyUpdate}
                              showCancelButton={true}
                            />
                          )}
                        {(isReplyEditMode === false ||
                          (isReplyEditMode === true &&
                            currSelReply !== null &&
                            currSelReply._id !== reply._id)) && (
                          <Fragment>
                            <p
                              className="mb-1 w-100 overflow-wrap-word"
                              dangerouslySetInnerHTML={{
                                __html: reply.message.replace(
                                  /(?:\r\n|\r|\n)/g,
                                  "<br />"
                                )
                              }}
                            ></p>
                            <p
                              className="font-demi-bold"
                              style={{ fontSize: "12px" }}
                            >
                              {fullName}&nbsp;|&nbsp;
                              {getFormattedMonthDateV3(reply.createdAt)}
                              {props.user !== null &&
                              reply.adminId &&
                              props.user._id === reply.adminId._id ? (
                                <Fragment>
                                  &nbsp;&nbsp;&nbsp;
                                  <i
                                    className="fas fa-edit color-light-grey pointer-cursor"
                                    onClick={e => {
                                      setReplyEditMode(reply);
                                    }}
                                  ></i>
                                </Fragment>
                              ) : (
                                ""
                              )}
                              {props.user !== null &&
                              (props.user.userType === "SUPER_ADMIN" ||
                                (reply.adminId &&
                                  props.user._id === reply.adminId._id)) ? (
                                <Fragment>
                                  &nbsp;&nbsp;&nbsp;
                                  <i
                                    className="fas fa-trash-alt color-red pointer-cursor"
                                    onClick={e => {
                                      showReplyDelModal(reply);
                                    }}
                                  ></i>
                                </Fragment>
                              ) : (
                                ""
                              )}
                            </p>
                          </Fragment>
                        )}
                      </div>
                    );
                  })}
              </div>
            </div>
          );
        })}
      {props.totalComments > 0 && (
        <Fragment>
          <br />
          <EntriesPagination
            showNoTotalCount={true}
            currPage={props.currFilters.skip}
            totalRecords={props.totalComments}
            paginationUpdated={props.paginationUpdated}
          />
        </Fragment>
      )}
    </div>
  );
};

export default CommentsList;

CommentsList.defaultProps = {
  comments: [],
  totalComments: 0,
  user: null,
  currFilters: { skip: 0 },
  updateComment: () => {},
  deleteComment: () => {},
  addCommentReply: () => {},
  updateCommentReply: () => {},
  deleteCommentReply: () => {},
  paginationUpdated: () => {}
};

CommentsList.propTypes = {
  comments: PropTypes.array,
  totalComments: PropTypes.number,
  user: PropTypes.object,
  currFilters: PropTypes.object,
  updateComment: PropTypes.func,
  deleteComment: PropTypes.func,
  addCommentReply: PropTypes.func,
  updateCommentReply: PropTypes.func,
  deleteCommentReply: PropTypes.func,
  paginationUpdated: PropTypes.func
};
